module.exports = __webpack_public_path__ + "img/album13_13.5fa00783.jpg";